
import PageHeader from 'layout/components/PageHeader';
import PageContainer from 'layout/components/PageContainer';
import RulesConfigurationForm from './components/RulesConfigurationForm/RulesConfigurationForm';
import { CREATE, TABLE } from 'shared/constans';
import { useRef, useState } from 'react';
import { Button } from '@vadiun/react-components';
import { createTableScrollHandler } from 'utils/tableUtils';
import TrafficLightRulesConfigurationsTable from './components/TrafficLightRulesConfigurationsTable';
import { useTrafficLightRulesConfigurations } from './hooks/useTrafficLightRulesConfigurations';

const TrafficLightRulesConfigurationPage = () => {
  const tableRef = useRef<HTMLDivElement>(null);
  const [visiblePage, setVisiblePage] = useState(TABLE);

  const {
    semaphoreRuleGroups,
    createMutation,
    deleteMutation,
  } = useTrafficLightRulesConfigurations();

  const handleCreate = async (values: any) => {
    try {
      await createMutation.mutate(values);
      setVisiblePage(TABLE);
    } catch (error) {
      // El snackbar de error se maneja en la mutación.
    }
  };

  return (  
    <div ref={tableRef}>
      <PageHeader
        area="Inventarios"
        subArea="Gestión Semáforos"
        title="Configuración de Reglas"
        toolbar={
          <Button
            onClick={() => setVisiblePage(visiblePage === TABLE ? CREATE : TABLE)}
            variant="light"
          >
            {visiblePage === TABLE ? 'Crear Regla' : 'Volver'}
          </Button>
        }
      />
      <PageContainer >
        {visiblePage === TABLE && (
          <TrafficLightRulesConfigurationsTable
            handlePageChange={createTableScrollHandler(tableRef)}
            configurations={semaphoreRuleGroups.data}
            totalItems={semaphoreRuleGroups.totalItems}
            onChangePage={semaphoreRuleGroups.handleChangePage}
            onChangeRowsPerPage={semaphoreRuleGroups.handleChangeRowsPerPage}
            rowsPerPage={semaphoreRuleGroups.rowsPerPage}
            onDelete={deleteMutation.mutate}
            loadingDelete={deleteMutation.isLoading}
            reload={semaphoreRuleGroups.reload}
          />
        )}
        {visiblePage === CREATE && (
          <div className="flex justify-center items-center w-full">
            <RulesConfigurationForm onSubmit={handleCreate} />
          </div>
        )}
      </PageContainer>
    </div>
  );
};

export default TrafficLightRulesConfigurationPage;